var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333984 2.0026C0.333984 1.08213 1.08018 0.335938 2.00065 0.335938H2.01065C2.93113 0.335938 3.67732 1.08213 3.67732 2.0026C3.67732 2.92308 2.93113 3.66927 2.01065 3.66927H2.00065C1.08018 3.66927 0.333984 2.92308 0.333984 2.0026Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333984 7.0026C0.333984 6.08213 1.08018 5.33594 2.00065 5.33594H2.01065C2.93113 5.33594 3.67732 6.08213 3.67732 7.0026C3.67732 7.92308 2.93113 8.66927 2.01065 8.66927H2.00065C1.08018 8.66927 0.333984 7.92308 0.333984 7.0026Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333984 12.0026C0.333984 11.0821 1.08018 10.3359 2.00065 10.3359H2.01065C2.93113 10.3359 3.67732 11.0821 3.67732 12.0026C3.67732 12.9231 2.93113 13.6693 2.01065 13.6693H2.00065C1.08018 13.6693 0.333984 12.9231 0.333984 12.0026Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsVertical);
export default __webpack_public_path__ + "static/media/options-vertical.dd06974ad4c73bf8aba7cd899f3828e9.svg";
export { ForwardRef as ReactComponent };